import AccessKeyDuck from '@aytm/app/insights/dashboard/duckness/ducks/AccessKeyDuck/AccessKeyDuck'
import { ACCESS_KEY_ACTIONS } from '@aytm/app/insights/dashboard/duckness/ducks/AccessKeyDuck/AccessKeyDuck.actions'
import type { DuckActionPayloadTuple } from '@aytm/app/insights/dashboard/duckness/poolDispatch'

//as DuckActionPayloadTuple<object>
export const makeFetchAccessKeyAction = (sharedKey: string) =>
  [AccessKeyDuck.duckName, ACCESS_KEY_ACTIONS.FETCH_ACCESS_KEY, { sharedKey }] as DuckActionPayloadTuple<{
    sharedKey: string
  }>
